import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ViewAccount from './ViewAccount';
import Loading from '../shared/Loading';
import { storeWithExpiration } from '../../utils/common';
import { getAccountById, getAccountCCEmails } from '../../actions/superadmin';

export class ViewAccountContainer extends Component {
  static propTypes = {
    accountId: PropTypes.string.isRequired,
    accountCCEmails: PropTypes.object.isRequired,
    currAccount: PropTypes.object.isRequired,
    getAccountByIdAction: PropTypes.func.isRequired,
    getAccountCCEmailsAction: PropTypes.func.isRequired,
    progress: PropTypes.number.isRequired,
  };

  componentWillMount = () => {
    const { getAccountByIdAction, getAccountCCEmailsAction, accountId } = this.props;
    const token = storeWithExpiration.get('token');
    getAccountByIdAction(accountId, token);
    getAccountCCEmailsAction(accountId, token);
  };

  render() {
    const { accountCCEmails, currAccount, progress } = this.props;
    const isLoaded = progress < 1 || currAccount.id !== 0;
    return isLoaded ? (
      <div className="container">
        <ViewAccount account={currAccount} accountCCEmails={accountCCEmails} />
      </div>
    ) : (
      <Loading />
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { progress, superadmin } = state;
  const { params: { accountId } } = ownProps;
  const currAccount = superadmin.get('currAccount');
  const accountCCEmails = superadmin.get('accountCCEmails');
  return { accountId, accountCCEmails, currAccount, progress };
}

export default connect(mapStateToProps, {
  getAccountByIdAction: getAccountById,
  getAccountCCEmailsAction: getAccountCCEmails,
})(ViewAccountContainer);
